import { render, staticRenderFns } from "./deliveryResultNav.vue?vue&type=template&id=7653b916"
import script from "./deliveryResultNav.vue?vue&type=script&lang=js"
export * from "./deliveryResultNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports